import {
    BarElement,
    CategoryScale,
    Chart,
    ChartData,
    ChartOptions,
    Legend,
    LinearScale,
    Title,
    Tooltip,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import React from "react";
import { Bar } from "react-chartjs-2";
import { connect, ConnectedProps } from "react-redux";

import { StoreState } from "store";
import { resolveColor } from "utils/commonFunctions";

const connector = connect((state: StoreState) => ({
    theme: state.themeReducer.theme,
}));

interface ChartProps {
    chartData: ChartData<"bar">;
    displayLegend?: boolean;
    horizontalStacking?: boolean;
    verticalStacking?: boolean;
}

type Props = ChartProps & ConnectedProps<typeof connector>;

Chart.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ChartDataLabels);

const BarChartWidget = ({ displayLegend = false, ...props }: Props): JSX.Element => {
    const getChartOptions = (gridLineColor: string, textColor: string): ChartOptions<"bar"> => {
        return {
            scales: {
                x: {
                    grid: {
                        display: false,
                    },
                    ticks: {
                        color: textColor,
                    },
                    stacked: props.horizontalStacking,
                    offset: true,
                },

                y: {
                    display: true,
                    grid: {
                        color: gridLineColor,
                    },
                    beginAtZero: true,
                    ticks: {
                        color: textColor,
                        maxTicksLimit: 6,
                    },
                    stacked: props.verticalStacking,
                },
            },
            elements: {
                point: {
                    radius: 0,
                },
            },
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
                legend: {
                    display: displayLegend,
                    position: "bottom",
                    labels: {
                        usePointStyle: true,
                        color: textColor,
                    },
                },
                tooltip: {
                    enabled: true,
                },
                datalabels: {
                    display: false,
                },
            },
        };
    };

    return (
        <Bar
            data={props.chartData}
            options={getChartOptions(resolveColor("--app-chart-gridLineColor"), resolveColor("--app-chart-textColor"))}
        />
    );
};
export default connector(BarChartWidget);
